import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

function Capacitaciones({ perfil }) {
  const [capacitaciones, setCapacitaciones] = useState([]);
  const [subiendo, setSubiendo] = useState(false);
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [archivo, setArchivo] = useState(null);

  const esAdmin = perfil?.rol === 'admin' || perfil?.rol === 'rrhh';

  useEffect(() => {
    cargarCapacitaciones();
  }, []);

  async function cargarCapacitaciones() {
    const { data } = await supabase
      .from('capacitaciones')
      .select('*')
      .order('created_at', { ascending: false });
    setCapacitaciones(data || []);
  }

  async function subirCapacitacion() {
    if (!archivo || !titulo) return alert('Completá el título y seleccioná un PDF');
    setSubiendo(true);

    const nombre = `cap_${Date.now()}.pdf`;
    const { error: uploadError } = await supabase.storage.from('fotos').upload(nombre, archivo);
    if (uploadError) { alert('Error al subir'); setSubiendo(false); return; }

    const { data: urlData } = supabase.storage.from('fotos').getPublicUrl(nombre);
    await supabase.from('capacitaciones').insert([{
      titulo,
      descripcion,
      url: urlData.publicUrl
    }]);

    setTitulo('');
    setDescripcion('');
    setArchivo(null);
    cargarCapacitaciones();
    setSubiendo(false);
  }

  async function eliminarCapacitacion(id) {
    if (!window.confirm('¿Eliminar esta capacitación?')) return;
    await supabase.from('capacitaciones').delete().eq('id', id);
    cargarCapacitaciones();
  }

  return (
    <div className="seccion-container">
      <h2 className="seccion-titulo-pag">📚 Capacitaciones</h2>

      {esAdmin && (
        <div className="upload-card">
          <h3>Subir capacitación</h3>
          <input
            type="text"
            placeholder="Título de la capacitación"
            value={titulo}
            onChange={e => setTitulo(e.target.value)}
          />
          <input
            type="text"
            placeholder="Descripción (opcional)"
            value={descripcion}
            onChange={e => setDescripcion(e.target.value)}
          />
          <label className="btn-upload">
            {archivo ? `📄 ${archivo.name}` : '📁 Seleccionar PDF'}
            <input type="file" accept=".pdf" onChange={e => setArchivo(e.target.files[0])} hidden />
          </label>
          <button className="btn-subir" onClick={subirCapacitacion} disabled={subiendo}>
            {subiendo ? 'Subiendo...' : '⬆️ Subir capacitación'}
          </button>
        </div>
      )}

      <div className="lista-capacitaciones">
        {capacitaciones.length === 0
          ? <p className="dashboard-vacio">No hay capacitaciones cargadas todavía.</p>
          : capacitaciones.map(c => (
            <div key={c.id} className="capacitacion-item">
              <div className="capacitacion-info">
                <div className="capacitacion-titulo">{c.titulo}</div>
                {c.descripcion && <div className="capacitacion-desc">{c.descripcion}</div>}
                <div className="capacitacion-fecha">
                  {new Date(c.created_at).toLocaleDateString('es-AR')}
                </div>
              </div>
              <div className="recibo-acciones">
                <a href={c.url} target="_blank" rel="noreferrer" className="btn-ver-recibo">
                  👁️ Ver
                </a>
                {esAdmin && (
                  <button className="btn-eliminar-recibo" onClick={() => eliminarCapacitacion(c.id)}>
                    🗑️
                  </button>
                )}
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default Capacitaciones;